import type { FC } from 'react'
import React from 'react'

import ConfirmationButton from '@/components/inputs/ConfirmationButton'
import CustomButton from '@/components/inputs/CustomButton'

type Props = {
  shouldShowConfirmation?: boolean
  children: React.ReactNode
  buttonProps: {
    disabled?: boolean
    startIcon: React.ReactNode
    'data-testid'?: string
  }
  dialogProps: {
    title: string
    description: string
    warning?: string
  }
  isLoading?: boolean
  onSubmit: () => void | Promise<void>
}

const SubmitButton: FC<Props> = ({
  shouldShowConfirmation,
  children,
  buttonProps,
  dialogProps,
  isLoading = false,
  onSubmit,
}) => {
  return shouldShowConfirmation ? (
    <ConfirmationButton buttonProps={buttonProps} dialogProps={dialogProps} isLoading={isLoading} onSubmit={onSubmit}>
      {children}
    </ConfirmationButton>
  ) : (
    <CustomButton
      {...buttonProps}
      disabled={buttonProps.disabled || isLoading}
      variant={'contained'}
      onClick={onSubmit}
    >
      {children}
    </CustomButton>
  )
}

export default SubmitButton
